import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackageSecurity: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="package-security,delivery"><path d="M11.75 20.25H3.75V3.75H8.75M8.75 3.75H15.25M8.75 3.75V9.25H15.25V3.75M15.25 3.75H20.25V10.25M14.75 14.5V17.4435C14.75 19.4994 16.3943 20.2864 18 21C19.6057 20.2864 21.25 19.4994 21.25 17.4435V14.5C19 13.2253 17 13.2253 14.75 14.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPackageSecurity;
